import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    
    const api = await getAxiosInstance();
    const getParams = (key) => {
    
      if (params?.[key] !== false) {
        if(params?.[key] !== undefined) {
          return `${key}=${params[key]}&`;
        } 
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?${getParams("sort_by")}sort_order=${
          params?.sort_order || "desc"
        }&per_page=${params?.per_page || "10"}&${getParams("search")}page=${
          params?.page || 1
        }&${getParams("sort_by_payment")}&${getParams("sort_by_status")}&${getParams(
          "from"
        )}${getParams("to")}`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const transactions = createApi({
  reducerPath: "transactionsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["transactions"],
  endpoints: (builder) => ({
    getListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/payment-transaction/list`,
      }),
      providesTags: ["transactions"],
    }),
    updateTableFieldsData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/admin/table-permission-create`,
      }),

      invalidatesTags: ["transactions"],
    }),
    updateStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `v1/admin/order/change-status`,
      }),

      invalidatesTags: ["transactions"],
    }),
    getOrderDetailData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/order/detail?order_id=${values.order_id}`,
      }),
      providesTags: ["transactions"],
    }),
    getProductDetailData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/order/product-detail?product_id=${values.product_id}`,
      }),
      providesTags: ["transactions"],
    }),
  }),
});

export const { useGetListDataQuery, useUpdateStatusMutation, useUpdateTableFieldsDataMutation, useGetOrderDetailDataQuery, useGetProductDetailDataQuery } = transactions;
